module.exports = __webpack_public_path__ + "img/beijingse_6.aaf2e601.png";